module.exports = __webpack_public_path__ + "img/Base-Size-Reference2@2x.6dda544d.jpg";